/**
 * Users-Access Tab
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UserAccessSettingsState = {
  userAccessSettings: null,
  userAccessSettingsLoading: false,
}

export const UserAccessSettingsActions = {
  createUserAccessSettings: async ({ commit }, value) => {
    commit('setUserAccessSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'userAccess',
        value,
      }).
      then(({ data }) => {
        commit('setUserAccessSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setUserAccessSettingsLoading', false))
  },

  getUserAccessSettings: async ({ commit }) => {
    commit('setUserAccessSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/userAccess').
      then(({ data }) => {
        commit('setUserAccessSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setUserAccessSettingsLoading', false))
  },

  updateUserAccessSettings: async ({ getters, commit }, value) => {
    commit('setUserAccessSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.userAccessSettingsId}`, {
        name: 'userAccess',
        value,
      }).
      then(({ data }) => {
        commit('setUserAccessSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setUserAccessSettingsLoading', false))
  },

  deleteUserAccessSettings: async ({ getters, commit }) => {
    commit('setUserAccessSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.userAccessSettingsId}`).
      then(({ data }) => {
        commit('setUserAccessSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setUserAccessSettingsLoading', false))
  },
}

export const UserAccessSettingsMutations = {
  setUserAccessSettings: (state, payload) => { state.userAccessSettings = payload },
  setUserAccessSettingsLoading: (state, payload) => { state.userAccessSettingsLoading = payload },
  setUserAccessSettingsValue: (state, payload) => { state.userAccessSettings.value = payload },
}

export const UserAccessSettingsGetters = {
  userAccessSettings: state => state.userAccessSettings,
  userAccessSettingsId: state => state.userAccessSettings?.id,
  userAccessSettingsLoading: state => state.userAccessSettingsLoading,
  userAccessSettingsValue: state => state.userAccessSettings?.value,
}
